module.exports = __webpack_public_path__ + "static/assets/3a9d473d2d38d4f738d9792d3094bfae.png";